import {
    FETCH_SCORESCHEMES_FAILURE,
    FETCH_SCORESCHEMES_REQUEST,
    FETCH_SCORESCHEMES_SUCCESS
} from "./scoreSchemesTypes"

const initialState = {
    loading: false,
    scoreSchemes: [],
    error: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SCORESCHEMES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_SCORESCHEMES_SUCCESS:
            return {
                loading: false,
                scoreSchemes: action.payload,
                error: '',
            }
        case FETCH_SCORESCHEMES_FAILURE:
            return {
                loading: false,
                scoreSchemes: [],
                error: action.payload
            }
        default: return state;
    }
}
export default reducer;